import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

var getBreadcrumbs = function getBreadcrumbs(partialTree, currentFolderId) {
  var folder = partialTree.find(function (f) {
    return f.id === currentFolderId;
  });
  var breadcrumbs = []; // eslint-disable-next-line no-constant-condition

  var _loop = function _loop() {
    breadcrumbs = [folder].concat(_toConsumableArray(breadcrumbs));
    if (folder.type === 'root') return "break";
    var currentParentId = folder.parentId;
    folder = partialTree.find(function (f) {
      return f.id === currentParentId;
    });
  };

  while (true) {
    var _ret = _loop();

    if (_ret === "break") break;
  }

  return breadcrumbs;
};

export default getBreadcrumbs;